import * as React from 'react';
import { cn } from '@anytag/shared-utils';

function Table({ className, ...props }: React.ComponentProps<'table'>) {
  return (
    <div data-slot="table-container" className="relative max-h-[inherit] w-full overflow-x-auto">
      <table data-slot="table" className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </div>
  );
}

function TableHeader({ className, ...props }: React.ComponentProps<'thead'>) {
  return (
    <thead data-slot="table-header" className={cn('h-12 [&_tr]:border-b [&_tr]:border-border', className)} {...props} />
  );
}

function TableBody({ className, style, ...props }: React.ComponentProps<'tbody'>) {
  return (
    <tbody
      data-slot="table-body"
      className={cn('[&_tr:last-child]:border-0', className)}
      style={{ ['--row-height' as string]: '52px', ...style }}
      {...props}
    />
  );
}

function TableFooter({ className, ...props }: React.ComponentProps<'tfoot'>) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn('bg-muted/50 border-t font-medium [&>tr]:last:border-b-0', className)}
      {...props}
    />
  );
}

function TableRow({ className, style, ...props }: React.ComponentProps<'tr'>) {
  return (
    <tr
      data-slot="table-row"
      style={{ ['--gradient-width' as string]: '1rem', ...style }}
      className={cn(
        'data-[state=selected]:bg-muted border-b border-border transition-colors hover:[&_[data-slot="table-cell"]]:bg-light-gray',
        className
      )}
      {...props}
    />
  );
}

function TableHead({ className, ...props }: React.ComponentProps<'th'>) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        'relative box-border h-12 bg-light-gray px-2 text-left align-middle text-sm font-semibold whitespace-nowrap [&:first-of-type]:pl-4 [&:last-of-type]:pr-4 [&>[role=checkbox]]:translate-y-[2px]',
        className
      )}
      {...props}
    />
  );
}

function TableCell({ className, ...props }: React.ComponentProps<'td'>) {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        'relative h-[var(--row-height)] bg-white px-2 align-middle whitespace-nowrap [&:first-of-type]:pl-4 [&:last-of-type]:pr-4 [&>[role=checkbox]]:translate-y-[2px]',
        className
      )}
      {...props}
    />
  );
}

function TableCaption({ className, ...props }: React.ComponentProps<'caption'>) {
  return (
    <caption data-slot="table-caption" className={cn('text-muted-foreground mt-4 text-base', className)} {...props} />
  );
}

// TODO: remove this NewTable constant later because those components violates with existing Table components
export const NewTable = { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
